import React, { useEffect } from "react";
import TextAreaQuill from "../../../../general/components/Textarea/Quilljs/TextAreaQuill";
import { useState } from "react";
import { classNames } from "../../../../general/functions/propsComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  GetPrivateNote,
  SetPrivateNote,
} from "../../actions/privateNoteActions";

const setInitStatus = (v) => {
  switch (v) {
    case "TYPING":
      return { name: "TYPING", desc: "Typing...", color: "bg-gray-200" };
    case "SEND":
      return { name: "SEND", desc: "Send..", color: "bg-gray-200" };
    case "SUCCESS":
      return { name: "SUCCESS", desc: "Saved", color: "bg-green-200" };
    case "ERROR":
      return { name: "ERROR", desc: "Can't save", color: "bg-red-200" };
    default:
      return null;
  }
};

export default function PrivateNote() {
  const [state, setState] = useState({ value: null });
  const [loadingAwal, setLoadingAwal] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);
  const [statusSave, setStatus] = useState();
  const storeSet = useSelector((state) => state.smvm_set_privatenote);
  const storeGet = useSelector((state) => state.smvm_get_privatenote);
  const dispatch = useDispatch();
  const handleChange = (value) => {
    console.log(value);
    setSaveLoading(true);
    setStatus(setInitStatus("TYPING"));
    setState({ value });
  };
  useEffect(() => {
    dispatch(GetPrivateNote());
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      console.log("Send to server");
      if (storeGet?.data?.data != state.value && loadingAwal == false) {
        setStatus(setInitStatus("SEND"));
        dispatch(SetPrivateNote(state.value));
        setSaveLoading(true);
      }
      if (storeGet?.data?.data == state.value && loadingAwal == true) {
        setLoadingAwal(false);
        setStatus(setInitStatus("SUCCESS"));
      }
    }, [2000]);
    return () => clearTimeout(timer);
  }, [state.value]);

  useEffect(() => {
    if (storeGet.success) {
      // setStatus(setInitStatus("SUCCESS"));
      handleChange(storeGet.data.data);
      // console.log("Validasi success", storeGet.data.data);
    }
    // if (storeGet.error) {
    //   console.log("Here error store");
    // }
  }, [storeGet]);
  useEffect(() => {
    if (storeSet.success) {
      setSaveLoading(false);
      setStatus(setInitStatus("SUCCESS"));
    }
    if (storeSet.error) {
      setSaveLoading(false);
      setStatus(setInitStatus("ERROR"));
    }
  }, [storeSet]);
  return (
    <div style={{ height: "" }}>
      <TextAreaQuill value={state.value} onChange={handleChange} />
      <div className="flex pt-1 justify-end">
        <div
          className={classNames(
            statusSave?.color,
            "text-xs font-semibold text-gray-600 px-2 py-1 rounded-lg w-auto"
          )}
        >
          {statusSave?.desc}
        </div>
      </div>
    </div>
  );
}
